import React, { useState } from "react";
import firestore from "../../firebase.config";
import { Typography, TextField, Button } from "@material-ui/core";

export default function AddVideo() {
    const [title, setTitle] = useState();
    const [url, setURL] = useState();
    const [category, setCategory] = useState();

    const [videoId, setVideoId] = useState();

    const getVideoId = (link) => {
        var regExp =
            /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = link.match(regExp);
        return match && match[7].length == 11 ? match[7] : false;
    };

    const handleSubmit = (evt) => {
        evt.preventDefault();
        console.log("title", title);
        console.log("url", url);
        console.log("category", category);

        const id = getVideoId(url);

        const vidObj = {
            avgRating: 0,
            category: category,
            title: title,
            videoId: getVideoId(url),
            view: 0,
            youtubeId: getVideoId(url),
        };

        const res = firestore
            .collection("videos")
            .doc(id)
            .set(vidObj)
            .then(() => {
                console.log("added ", vidObj);
                window.location.reload();
            })
            .catch((err) => {
                console.log(err);
            });
        console.log(res);
    };

    const handleURLChange = (val) => {
        const id = getVideoId(val);
        console.log(id);
        setVideoId(id);
    };

    return (
        <div style={{ padding: 30 }}>
            <Typography variant="h6" id="tableTitle" component="div">
                Add New Video
            </Typography>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "0 auto",
                }}
            >
                <div
                    style={{
                        height: 300,
                        width: 300,
                        margin: "0 auto",
                        paddingTop: 20,
                    }}
                >
                    <img
                        src={`https://img.youtube.com/vi/${videoId}/default.jpg`}
                        height={300}
                        width={300}
                        alt="thumbnail"
                    />
                </div>
                <form onSubmit={handleSubmit}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "80%",
                            margin: "0 auto",
                            paddingTop: 30,
                        }}
                    >
                        <Typography gutterBottom>Title</Typography>
                        <TextField
                            inputProps={{
                                min: 0,
                                style: { textAlign: "center" },
                            }}
                            value={title}
                            onInput={(e) => setTitle(e.target.value)}
                        />
                        <Typography gutterBottom>Youtube Link</Typography>
                        <TextField
                            inputProps={{
                                min: 0,
                                style: { textAlign: "center" },
                            }}
                            value={url}
                            onInput={(e) => setURL(e.target.value)}
                            onChange={(e) => handleURLChange(e.target.value)}
                        />
                        <Typography gutterBottom>Category</Typography>
                        <TextField
                            inputProps={{
                                min: 0,
                                style: { textAlign: "center" },
                            }}
                            value={category}
                            onInput={(e) => setCategory(e.target.value)}
                        />
                        <div
                            style={{
                                width: 300,
                                margin: "0 auto",
                                paddingTop: 30,
                            }}
                        >
                            <Button
                                variant="contained"
                                color="primary"
                                type="submit"
                            >
                                Add Video
                            </Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}
